var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon":['fas', 'euro-sign'],"icon-right":"","statistic":_vm.orderValue,"statisticTitle":"Totale waarde","color":"success"}})}
var staticRenderFns = []

export { render, staticRenderFns }